import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import {type APIOrganizationPerson} from 'web-app/react/entities/organization-persons/model';

export const getOrganizationPerson = (organizationId: string, organizationPersonId: string) => {
    return RESTClient.getAuthenticatedObservable(`v2/organizations/${organizationId}/persons/${organizationPersonId}`);
};

export const getOrganizationPersons = (organizationId: string) => {
    return RESTClient.getAuthenticatedObservable(`v2/organizations/${organizationId}/persons`);
};

export const createOrganizationPerson = (organizationId: string, organizationPerson: APIOrganizationPerson) => {
    return RESTClient.postAuthenticatedObservable(`v2/organizations/${organizationId}/persons`, organizationPerson);
};

export const updateOrganizationPerson = (
    organizationId: string,
    organizationPersonId: string,
    organizationPerson: APIOrganizationPerson,
) => {
    return RESTClient.postAuthenticatedObservable(
        `v2/organizations/${organizationId}/persons/${organizationPersonId}`,
        organizationPerson,
    );
};

export const deleteOrganizationPerson = (organizationId: string, organizationPersonId: string) => {
    return RESTClient.deleteAuthenticatedObservable(
        `v2/organizations/${organizationId}/persons/${organizationPersonId}`,
    );
};
